import React from 'react'
import BookingStatus from './clientHome/BookingStatus'
const Scheduling = () => {
  return (
    <div className="w-[85%] mx-auto p-6">
      <BookingStatus />

      
    </div>
  )
}

export default Scheduling